import makeStyles from "@mui/styles/makeStyles";
import { FontFamilySwitch } from "../../utils";
export const AggrementDetailsStyles = makeStyles((theme) => ({

    tabtitle: {
        fontSize:"0.75rem",
        color: '#4E5A6B',
        fontFamily: FontFamilySwitch().bold,
    },
    tabtitle1: {
        fontSize:"0.75rem",
        color: '#5078E1',
        fontFamily: FontFamilySwitch().bold,
    },
    subtabtitle: {
        fontSize:"0.75rem",
        color: '#4E5A6B',
        fontFamily: FontFamilySwitch().regular,
    },
    subtabtitle1: {
        fontSize:"0.75rem",
        color: '#5078E1',
        fontFamily: FontFamilySwitch().regular,
    },
    selectBack1: {
        // backgroundColor: '#F1F7FF',
        display: 'flex',
        alignItems: 'center',
        padding: '10px 16px',
        borderTopLeftRadius: "12px",
        // borderTopRightRadius: "12px",
        borderRight:"1px solid #E4E8EE"
    },
    selectBack: {
        display: 'flex',
        alignItems: 'center',
        padding: '10px 16px',
        borderTopLeftRadius: "12px",
        // borderTopRightRadius: "12px",
        borderRight:"1px solid #E4E8EE"
    },
    icon: {
        color: "#7D534C",
        backgroundColor: "#FEEAEA80",
        borderRadius: "6px",
        fontSize:"42px",
        padding: "10px"

    },

    invoicedetails: {
        borderRadius: "8px",
        overflow: "hidden",
        boxShadow: "0px 0px 16px #00000014",

    }
}));